import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose, isEmpty } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { codelistProvider } from 'components';
import { codelists } from 'constants/codelists';
import { getContacts } from 'features/views/contacts/selectors';
import { history } from 'utils';
import PrintContactDetail from 'pages/PrintContactDetail';

export const PrintContactsList = ({ idkAgenciesCodelist, idkRegionsCodelist }) => {
	const { state } = useLocation();
	const contacts = useSelector(getContacts(state.view));
	const readyToRender = contacts && !isNilOrEmpty(idkAgenciesCodelist) && !isNilOrEmpty(idkRegionsCodelist);

	useEffect(() => {
		if (isEmpty(contacts)) {
			history.go(-1);
		} else {
			if (!isNilOrEmpty(idkAgenciesCodelist) && !isNilOrEmpty(idkRegionsCodelist)) {
				setTimeout(() => handleOpenPrintWindow(), 1500);
			}
		}
		// eslint-disable-next-line
	}, [idkAgenciesCodelist, idkRegionsCodelist]);

	const handleOpenPrintWindow = () => {
		window.print();
	};

	return (
		readyToRender &&
		contacts.map((contact, i) => {
			return <PrintContactDetail key={i} printList contactItem={contact} />;
		})
	);
};

PrintContactsList.propTypes = {
	idkAgenciesCodelist: PropTypes.array,
	idkRegionsCodelist: PropTypes.array,
};

export default compose(
	codelistProvider(codelists.idkRegions, 'idkRegionsCodelist'),
	codelistProvider(codelists.idkAgencies, 'idkAgenciesCodelist'),
)(PrintContactsList);
